import { useMemo, useState } from 'react';
import { get } from 'lodash';
import { useIntl } from 'modules/taboola-common-frontend-modules/i18n';

export const useFilterTypeState = ({ initialFilter, types, disabledTypes, availableFiltersMap }) => {
    const { type: initialType } = initialFilter || {};
    const onlyAvailableType = types.length === 1 ? types[0] : null;
    const [type, setType] = useState(initialType || onlyAvailableType);
    const { formatMessage } = useIntl();
    const filterTypeOptions = useMemo(() => {
        const options = types.map(type => ({
            value: type,
            label:
                get(availableFiltersMap, `${type}.label`) ||
                formatMessage({
                    id: `app.campaigns.reports.filters.type.${type}`,
                    defaultMessage: type,
                }),
            isDisabled: disabledTypes.has(type),
        }));

        options.sort((a, b) => a.label.localeCompare(b.label));

        return options;
    }, [types, availableFiltersMap, disabledTypes, formatMessage]);

    return { type, setType, filterTypeOptions };
};
